import firebase from "firebase";

export default async (req: any) => {
  const token = localStorage.getItem("token");
  console.log(token);
  if (token) {
    req.headers.Authorization = `${token}`;
  }
  return req;
};
